import { getHomeUrl } from '@/utils/cp-context';
import type { Breadcrumb } from '@ps-refarch-ux/neon';
import { STAFF_GRID_PAGINATION_THRESHOLD } from './grid-constants';

/** Subject area empty-state copy (same pattern as course-catalog-constants). */
export enum EMPTY_SUBJECT_AREA_TEXT {
  Title = 'No subject areas',
  Body = 'Add your first subject area to organize your course catalog and help students explore their learning options.',
  Button = 'Add subject area',
}

export enum EMPTY_SUBJECT_AREA_ID {
  Button = 'no-subject-area',
}

export enum SUBJECT_AREAS_ID {
  Breadcrumbs = 'subject-areas-breadcrumbs',
  Button = 'add-subject-area',
}

export enum SUBJECT_AREAS_TEXT {
  BreadcrumbHome = 'Home',
  Title = 'Subject areas',
  Description = 'Add and manage subject areas for all courses you will import to ensure each course maps to the correct area.',
  Info = 'Duplicate subject area names appear with their SCED code in the course catalog. In plans of study, they are combined into one option for selection.',
  Button = 'Add subject area',
  SCEDToolTip = 'The SCED subject code identifies how a subject area aligns with the School Courses for the Exchange of Data (SCED) classification system for secondary school courses. SCED is the preferred and most up-to-date standard for course coding.',
  EditAndDeleteToolTip = 'You must move all associated courses to a different subject area before you can edit or delete this subject area.',
  DuplicateCombinationError = 'Choose a unique subject area name and SCED code combination.',
}
export enum SUBJECT_AREAS_ICON {
  Add = 'add',
  Info = 'status-information',
}

export const SUBJECT_AREA_NAME_REGEX = '^[^,_%$@?!]*$';
export const SUBJECT_AREA_NAME_REGEX_MODIFIERS = 'i';
export const SUBJECT_AREA_NAME_REGEX_ERROR_TEXT =
  'Subject area name cannot contain these characters: , _ % $ @ ? !';

export const getSubjectAreasBreadcrumbs: Array<Breadcrumb> = [
  { text: SUBJECT_AREAS_TEXT.BreadcrumbHome, url: getHomeUrl() },
  { text: SUBJECT_AREAS_TEXT.Title, url: '#' },
] as const;

export const SCEDSubjectCodes = [
  { code: 1, description: '01 English language and literature' },
  { code: 2, description: '02 Mathematics' },
  { code: 3, description: '03 Life and physical sciences' },
  { code: 4, description: '04 Social sciences and history' },
  { code: 5, description: '05 Visual and performing arts' },
  { code: 6, description: '06 Foreign language and literature (archived by SCED)' },
  { code: 7, description: '07 Religious education and theology' },
  { code: 8, description: '08 Physical, health, and safety education' },
  { code: 9, description: '09 Military science' },
  { code: 10, description: '10 Information technology' },
  { code: 11, description: '11 Communication and audio/visual technology' },
  { code: 12, description: '12 Business and marketing' },
  { code: 13, description: '13 Manufacturing' },
  { code: 14, description: '14 Health care sciences' },
  { code: 15, description: '15 Public, protective, and government services' },
  { code: 16, description: '16 Hospitality and tourism' },
  { code: 17, description: '17 Architecture and construction' },
  { code: 18, description: '18 Agriculture, food, and natural resources' },
  { code: 19, description: '19 Human services' },
  { code: 20, description: '20 Transportation, distribution, and logistics' },
  { code: 21, description: '21 Engineering and technology' },
  { code: 22, description: '22 Miscellaneous' },
  { code: 23, description: '23 Non-subject specific' },
  { code: 24, description: '24 World languages' },
  { code: 25, description: '25 Integrative learning' },
] as const;

export const SUBJECT_AREAS_GRID_HEADER_CLASS = 'neon-data-grid-header plans-of-study-header';
export const SUBJECT_AREAS_PAGINATION_THRESHOLD = STAFF_GRID_PAGINATION_THRESHOLD;

export const SUBJECT_AREAS_SKELETON_COLUMNS = ['33%', '33%', '33%'] as const;
